// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__cjRQI","notifications":"style_notifications__2J0A4","center":"style_center__16Oj7"};